import React from 'react';
import { Copy, Check } from 'lucide-react';

const OverviewHeader = ({ club, copied, onCopyCode }) => {
    if (!club) return null;

    return (
        <div className="mb-6">

            <div className="flex items-center gap-2 bg-green-50 px-4 py-2 rounded-lg inline-flex">
                <span className="text-sm font-medium">Club Code:</span>
                <span className="text-lg font-bold text-green-600">{club.code}</span>
                <button onClick={onCopyCode} className="ml-2 text-green-600">
                    {copied ? <Check size={16} /> : <Copy size={16} />}
                </button>
            </div>
        </div>
    );
};

export default OverviewHeader;
